<script>
    import { onMount } from 'svelte';
    import Loader from '../Loader.svelte';
    import {notifier} from '@beyonk/svelte-notifications';

    import Template from '../../Models/templateModel';

    export let params;
    let template_details;

    let unsub;

    function saveTemplate() {
        Template.save(template_details).then(() => notifier.success("Template Saved"));
    }

    function loadTemplate(id) {
        if (unsub) {
            unsub();
        }

        const template_model = new Template(id);

        unsub = template_model.getStore().subscribe((tpl) => {
            if (!tpl) return;

            template_details = tpl.details;
        })

    }

    $: loadTemplate(params.id);

    onMount(() => {
        return () => {
            if (unsub) {
                unsub();
            };
        }
    })
</script>

<Loader loading={!template_details}>
    <div class="container is-fluid">
        <form on:submit|preventDefault="{saveTemplate}">
            <h1 class="title is-1">
                {template_details.name}
                <div class="buttons is-pulled-right">
                    <a href="#/templates" class="button">Close</a>
                    <button class="button is-success">Save</button>
                </div>
            </h1>
            <div>
                <textarea class="textarea" bind:value={template_details.body}></textarea>
            </div>
        </form>

    </div>
</Loader>